"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterToURLSearchParams = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_select_1 = (0, tslib_1.__importDefault)(require("react-select"));
const infra_1 = require("@monorepo/infra");
const atoms_1 = require("../../atoms");
const S = (0, tslib_1.__importStar)(require("./styles"));
const filterToURLSearchParams = (urlSearchParams, filter) => {
    if (!urlSearchParams || !(0, infra_1.isObject)(filter)) {
        return urlSearchParams;
    }
    const keys = Object.keys(filter);
    for (let i = 0, l = keys.length; i < l; ++i) {
        const key = keys[i];
        const value = filter[key];
        if ((0, infra_1.isNonEmptyString)(value)) {
            urlSearchParams.append(key, encodeURIComponent(value));
        }
        if ((0, infra_1.isNonEmptyArray)(value)) {
            value.forEach((item) => urlSearchParams.append(`${key}[]`, encodeURIComponent(item)));
        }
    }
    return urlSearchParams;
};
exports.filterToURLSearchParams = filterToURLSearchParams;
const channelsOptions = infra_1.ChannelHelper.getChannelOptions();
const coopPermissionsOptions = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
    { value: 'allowance', label: 'Allowance' },
];
const TeamMembersListFilter = ({ onChange, }) => {
    const [filter, setFilter] = (0, react_1.useState)(undefined);
    const handleFilterChange = (value, name) => {
        if (!name) {
            return;
        }
        const newFilter = Object.assign(Object.assign({}, (filter ? Object.assign({}, filter) : {})), { [name]: value });
        if (!value || (Array.isArray(value) && !value.length)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete newFilter[name];
        }
        setFilter(newFilter);
        if ((0, infra_1.isFunction)(onChange)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(newFilter);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(S.FilterContainer, { children: [(0, jsx_runtime_1.jsx)(atoms_1.DebounceInput, { name: "name", placeholder: "Name", length: 3, wait: 1000, clearIcon: true, variant: "outlined", onChange: handleFilterChange }, void 0), (0, jsx_runtime_1.jsx)(atoms_1.DebounceInput, { name: "email", placeholder: "Email", length: 3, wait: 1000, clearIcon: true, variant: "outlined", onChange: handleFilterChange }, void 0), (0, jsx_runtime_1.jsx)(react_select_1.default, { name: "channels", placeholder: "Channel(s)", isMulti: true, isClearable: true, options: channelsOptions, components: {
                    IndicatorSeparator: () => null,
                }, onChange: (newValue) => {
                    var _a;
                    return handleFilterChange((_a = newValue) === null || _a === void 0 ? void 0 : _a.map((item) => item.value), 'channels');
                }, styles: S.SelectStyle }, void 0), (0, jsx_runtime_1.jsx)(react_select_1.default, { name: "groups", placeholder: "Role", isClearable: true, options: infra_1.DealerHelper.dealerGroups, components: {
                    IndicatorSeparator: () => null,
                }, onChange: (newValue) => {
                    var _a;
                    return handleFilterChange((_a = newValue) === null || _a === void 0 ? void 0 : _a.value, 'groups');
                }, styles: S.SelectStyle }, void 0), (0, jsx_runtime_1.jsx)(react_select_1.default, { name: "coopPermission", placeholder: "Co-Op Permission", isClearable: true, options: coopPermissionsOptions, components: {
                    IndicatorSeparator: () => null,
                }, onChange: (newValue) => {
                    var _a;
                    return handleFilterChange((_a = newValue) === null || _a === void 0 ? void 0 : _a.value, 'coopPermission');
                }, styles: S.SelectStyle }, void 0), (0, jsx_runtime_1.jsx)(atoms_1.DebounceInput, { name: "coopBalance", placeholder: "Co-Op Balance", wait: 1000, clearIcon: true, variant: "outlined", onChange: (value, name) => {
                    if ((0, infra_1.isNumeric)(value) || ((0, infra_1.isString)(value) && !value)) {
                        handleFilterChange(value, name);
                    }
                } }, void 0)] }, void 0));
};
exports.default = TeamMembersListFilter;
